
// Import module styles.
import "./errorMessage.view.less";

// Define controllers.
window.pm14ud = {
	ErrorMessage
};

function ErrorMessage() {

	return {
		init: $init
	};

	// ---
	// PUBLIC METHODS.
	// ---

	function $init() {

		this.$el.focus();
		this.$refs.scrollTarget.scrollIntoView({
			behavior: "smooth",
			block: "start"
		});

	}

}
